export default "__VITE_ASSET__BwetnlF___"